<template>
  <div
    class="cert-card"
    :class="`cert-card--${color}`"
  >
    <!-- Card Header -->
    <div class="cert-card__header">
      <div class="cert-card__header-left">
        <div class="cert-card__icon-wrap">
          <feather-icon
            :icon="icon"
            size="20"
          />
        </div>
        <div>
          <h5 class="cert-card__title">
            {{ title }}
          </h5>
          <span class="cert-card__mode-badge">
            <feather-icon
              :icon="isVisible ? 'UnlockIcon' : 'LockIcon'"
              size="11"
              class="mr-25"
            />
            {{ isVisible ? 'Edit Mode Active' : 'View Only' }}
          </span>
        </div>
      </div>

      <div
        v-if="!loader"
        class="cert-card__header-actions"
      >
        <b-button
          v-if="!isVisible"
          size="sm"
          class="cert-card__btn cert-card__btn--edit"
          @click="$emit('toggle-edit')"
        >
          <feather-icon
            icon="Edit2Icon"
            size="14"
          />
          <span class="ml-50">Edit</span>
        </b-button>
        <b-button
          v-else
          size="sm"
          class="cert-card__btn cert-card__btn--cancel"
          @click="$emit('toggle-edit')"
        >
          <feather-icon
            icon="XIcon"
            size="14"
          />
          <span class="ml-50">Cancel</span>
        </b-button>
      </div>
    </div>

    <!-- Card Body -->
    <div class="cert-card__body">
      <div
        v-if="loader"
        class="cert-card__loader"
      >
        <b-spinner
          type="grow"
          variant="primary"
          small
        />
        <span class="ml-75 text-muted">Loading data...</span>
      </div>
      <div
        v-else
        class="cert-card__content"
        :class="{ 'cert-card__content--locked': !isVisible }"
        :style="{ pointerEvents: isVisible ? 'auto' : 'none' }"
      >
        <div
          v-if="!isVisible"
          class="cert-card__locked-hint"
        >
          <feather-icon
            icon="InfoIcon"
            size="14"
            class="mr-50"
          />
          Click <strong>Edit</strong> above to modify this section
        </div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: 'FileTextIcon',
    },
    color: {
      type: String,
      default: 'primary',
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
    loader: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
@import './certificates-wizard.scss';
</style>
